import { Button } from "@ofrz/ui-package";
import { StatusBadge } from "components/status-badge";
import { FilterTab } from "components/tab-filter/tab-filter.props";
import { COLORS } from "libs/colors";
import { DataTypes } from "libs/enums";
import { RedemptionClient } from "libs/models/products";
import { ViewIcon } from "static/images/svgs/view-icon-svg";
import { StringfyDate } from "utils/date";
import translate from "../../utils/translations";
import { BatchModel } from "libs/models/batch-model";
import { formatNumber } from "utils/numbers";
import {
  getBatchStatus,
  getBatchStatusStyle,
} from "pages/BatchDetailsView/batch-details.util";
export const DynamicTabKeys = [{ Status: DataTypes.Number }];
export const DynamicSearchKeys = {
  Version: DataTypes.String,
} as const;
export const productItemsHeaders = [
  {
    title: translate("Barcode_Text", "Barcode"),
    dataIndex: "barcode",
    key: "barcode",
    isSortable: false,
  },
  {
    title: translate("Value_Text", "Value TODO"),
    dataIndex: "balance",
    key: "balance",
    isSortable: false,
  },
  {
    title: translate("Status_Text", "Status TODO"),
    dataIndex: "status",
    key: "status",
    isSortable: false,
  },

  {
    title: translate("Activation_Date_Text", "Activation Date TODO"),
    dataIndex: "activatedAt",
    key: "activatedAt",
    isSortable: false,
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    isSortable: false,
  },
];
export const batchesHeaders = [
  {
    title: translate("Batch_Version_Text", "Batch version TODO"),
    dataIndex: "version",
    key: "version",
    isSortable: false,
  },
  {
    title: translate("Number_of_Cards_Text", "Number of Cards TODO"),
    dataIndex: "productItemsNumber",
    key: "productItemsNumber",
    isSortable: false,
  },
  {
    title: translate("Status_Text", "Status TODO"),
    dataIndex: "batchStatus",
    key: "batchStatus",
    isSortable: false,
  },

  {
    title: translate("Creation_Date_Text", "Creation Date TODO"),
    dataIndex: "createdAt",
    key: "createdAt",
    isSortable: false,
  },
  {
    title: translate("Validity_Period_Weeks_Text", "Validity Period TODO"),
    dataIndex: "validityPeriod",
    key: "validityPeriod",
    isSortable: false,
  },
  {
    title: "",
    dataIndex: "actions",
    key: "actions",
    isSortable: false,
  },
];
export const clientsHeaders = [
  {
    title: translate("Client_Name_Text", "Client Name TODO"),
    dataIndex: "clientName",
    key: "clientName",
    isSortable: false,
  },
  {
    title: translate("Margin_Fees_Text", "Margin Fees TODO"),
    dataIndex: "marginFees",
    key: "marginFees",
    isSortable: false,
  },
  {
    title: translate("Phone_Text", "Phone TODO"),
    dataIndex: "phone",
    key: "phone",
    isSortable: false,
  },
  {
    title: translate("Joined_At_Text", "Joined At TODO"),
    dataIndex: "joinedAt",
    key: "joinedAt",
    isSortable: false,
  },
];
export const getBatchesList = (
  batchesData: BatchModel[],
  onView: (batch: BatchModel) => void
) => {
  const data = [];
  for (var i = 0; i < batchesData.length; i++) {
    const request = batchesData[i];
    const row: Record<string, any> = {
      ...request,
      batchStatus: (
        <StatusBadge
          status={getBatchStatus(request.batchStatus)}
          style={getBatchStatusStyle(request.batchStatus)}
        />
      ),
      productItemsNumber: formatNumber(request.productItemsNumber),
      createdAt: StringfyDate(request.createdAt),
      actions: (
        <div className="flex space-x-2">
          <Button
            className={`${COLORS.TEXT_FORM} !p-0 m-2`}
            onClick={() => onView(request)}
          >
            <ViewIcon />
          </Button>
        </div>
      ),
    };
    data.push(row);
  }
  return data;
};

export const getRedemptionClientsList = (clients: RedemptionClient[]) => {
  const data = [];
  if (!clients) return [];
  for (var i = 0; i < clients.length; i++) {
    const request = clients[i];
    const row: Record<string, any> = {
      ...request,
      joinedAt: StringfyDate(request.joinedAt),
    };
    data.push(row);
  }
  return data;
};

export const getStatusStyle = (status: number) => {
  switch (status) {
    case 2:
      return "bg-[#ECFDF3] text-green-700 border-green-400";
    case 1:
      return "bg-gray-100 text-gray-700 border-gray-400";
    case 3:
      return "bg-[#FEE2E2] text-red-700 border-red-400";
    default:
      return "bg-gray-100 text-gray-700 border-gray-400";
  }
};
export const getStatus = (status: number) => {
  switch (status) {
    case 1:
      return translate("Ready_To_Print_Text", "Ready To Print");
    case 2:
      return translate("Printed_Text", "Printed");
    case 3:
      return translate("Canceled_Text", "Canceled");
    default:
      return translate("Paused_Text", "Paused");
  }
};

export const getProductType = (type: number) => {
  switch (type) {
    case 1:
      return "Closed Loop";
    case 2:
      return "Restricted Loop";
    default:
      return "Cross-Pollination";
  }
};
export const getProductUsageType = (type: number) => {
  switch (type) {
    case 1:
      return "Single Use";
    default:
      return "Multiple Use";
  }
};

export const productDetailsFilterTabs: FilterTab[] = [
  {
    id: 0,
    value: translate("Redemption_Channels_Text", "Redemption Channels"),
  },
  {
    id: 1,
    value: translate("Batches_Text", "Batches TODO"),
  },
];
